import { Link } from "react-router-dom";

export default function Footer({ content }) {
  const email = content?.contact?.email || "gustavo@dommar.ai";
  return (
    <footer data-testid="footer" className="bg-ink text-stone-50 px-6 md:px-12 lg:px-24 py-20">
      <div className="grid md:grid-cols-3 gap-12">
        <div>
          <div className="flex items-baseline gap-2">
            <span className="font-serif text-3xl">DOMMAR</span>
            <span className="font-sans text-[10px] tracking-[0.25em] uppercase text-stone-300">STUDIO</span>
          </div>
          <p className="font-sans text-sm text-stone-300 mt-4 max-w-xs leading-relaxed">
            Transformamos conocimiento en crecimiento mediante Inteligencia Artificial.
          </p>
        </div>
        <div>
          <h4 className="font-sans text-xs tracking-[0.2em] uppercase text-stone-300 mb-5">Navegación</h4>
          <ul className="space-y-3 font-serif text-xl">
            <li><Link to="/" className="hover:text-stone-300 transition-colors duration-300">Inicio</Link></li>
            <li><Link to="/blog" className="hover:text-stone-300 transition-colors duration-300">Blog</Link></li>
            <li><Link to="/login" className="hover:text-stone-300 transition-colors duration-300">Acceso</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-sans text-xs tracking-[0.2em] uppercase text-stone-300 mb-5">Contacto</h4>
          <a href={`mailto:${email}`} className="font-serif text-2xl hover:text-stone-300 transition-colors duration-300 break-all">{email}</a>
        </div>
      </div>
      <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between gap-4 font-sans text-xs text-stone-300">
        <span>© {new Date().getFullYear()} DOMMAR STUDIO. Todos los derechos reservados.</span>
        <span>Gustavo D'Ommar — AI Digital Partner</span>
      </div>
    </footer>
  );
}
